// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"111":"6f4c7682","144":"f7b1a7ee","379":"cf519c21","511":"1f331861","598":"a9b0743f","744":"ec529acf","948":"1635e091","985":"5514a939"}[chunkId] + ".chunk.js";
};